import { getAssetIconByAddress } from 'abis/set/asset-icons'
import Big from 'big.js'
import { AllocationData } from 'pages/index-details/interfaces'
import { CoinImg } from 'pages/index-details/styled'
import { getPricesStore } from 'services/price-history/utils'
import { assertMultiply, getAssetQuantityShortened, marketCapNumber } from 'utils'
import {
  Asset,
  AssetDataWithPrices,
} from '../../../../../services/query-v2/products/index/product-info/model'
import { ChainAsset } from 'services/price-history/interfaces'

export const headersAssets = [
  { name: 'Token' },
  { name: 'Allocation' },
  { name: 'Value' },
  { name: 'Quantity' },
]

//FIXME

export const byValue = (a: AssetDataWithPrices, b: AssetDataWithPrices): number => {
  assertMultiply(a.price, a.balance)
  assertMultiply(b.price, b.balance)
  if (a.price.mul(a.balance).gt(b.price.mul(b.balance))) {
    return -1
  } else if (a.price.mul(a.balance).lt(b.price.mul(b.balance))) {
    return 1
  }
  return 0
}

export const getFormattedAssetData = (assetData: Asset[]): (string | JSX.Element)[][] => {
  const prices = getPricesStore()
  let totalInUSD = Big(0)
  return assetData
    .map((item) => {
      const assetKey = `${item.chainID}:${item.asset}` as ChainAsset
      const assetPrices = Object.values(prices[assetKey])
      const assetPrice = Big(assetPrices[assetPrices.length - 1] ?? 0)
      return {
        ...item,
        price: Big(item.balance).eq(0) && assetPrice.eq(0) ? Big(0) : assetPrice,
      }
    })
    .sort(byValue)
    .map((item) => {
      const assetWeight = item.weight !== null ? Big(item.weight) : Big(0)
      assertMultiply(item.price, item.balance)
      totalInUSD = totalInUSD.add(item.price.mul(item.balance))

      assertMultiply(assetWeight.div(65535), 100)
      const modifiedSymbol = item.symbol.startsWith('PT-')
        ? item.symbol.split('-').slice(0, -1).join('-')
        : item.symbol

      const arr = [
        { coinAddress: item.asset, coinSymbol: modifiedSymbol },
        assetWeight.eq(0) ? '0%' : `${assetWeight.div(65535).mul(100).toFixed(2)}%`,
        item.balance === '0' ? '0' : item.price.mul(item.balance).toString(),
        Big(item.balance).eq(0) ? '0' : getAssetQuantityShortened(item),
      ]
      return arr
    })
    .map((item) => [
      <>
        <CoinImg
          key={(item[0] as AllocationData).coinAddress}
          src={getAssetIconByAddress((item[0] as AllocationData).coinAddress)}
        />
        {(item[0] as AllocationData).coinSymbol}
      </>,
      extractValue(
        `${
          totalInUSD.eq(0)
            ? 0
            : Big(item[2] as string)
                .div(totalInUSD)
                .mul(100)
                .toFixed(2)
        }%`,
      ),
      (item[2] as string).length > 1
        ? extractValue(marketCapNumber(item[2] as string, '$'))
        : `$${Big(item[2] as string).toFixed(2)}`,
      extractValue(item[3]),
    ])
}
const extractValue = (value: string | AllocationData) => {
  return value as string
}
